export default "__VITE_ASSET__ChA5OR1v__"